@if (topRightToasts.length > 0) {
  <div class="toast__container toast__container--top-right">
    @for (toast of topRightToasts; track toast) {
      <div
        class="toast__item"
        [ngClass]="'toast__item--' + toast.severity"
        [@rightAnimation]
        >
        <div class="toast__content">
          <div class="toast__icon">
            <i class="material-icons">{{ getIcon(toast.severity) }}</i>
          </div>
          <div class="toast__message">
            <div class="toast__summary">{{ toast.summary }}</div>
            @if (toast.detail) {
              <div class="toast__detail">{{ toast.detail }}</div>
            }
          </div>
          @if (toast.closable) {
            <button class="toast__close" (click)="removeToast(toast.id)">
              <i class="material-icons">close</i>
            </button>
          }
        </div>
      </div>
    }
  </div>
}

@if (topLeftToasts.length > 0) {
  <div class="toast__container toast__container--top-left">
    @for (toast of topLeftToasts; track toast) {
      <div
        class="toast__item"
        [ngClass]="'toast__item--' + toast.severity"
        [@leftAnimation]
        >
        <div class="toast__content">
          <div class="toast__icon">
            <i class="material-icons">{{ getIcon(toast.severity) }}</i>
          </div>
          <div class="toast__message">
            <div class="toast__summary">{{ toast.summary }}</div>
            @if (toast.detail) {
              <div class="toast__detail">{{ toast.detail }}</div>
            }
          </div>
          @if (toast.closable) {
            <button class="toast__close" (click)="removeToast(toast.id)">
              <i class="material-icons">close</i>
            </button>
          }
        </div>
      </div>
    }
  </div>
}

@if (bottomRightToasts.length > 0) {
  <div class="toast__container toast__container--bottom-right">
    @for (toast of bottomRightToasts; track toast) {
      <div
        class="toast__item"
        [ngClass]="'toast__item--' + toast.severity"
        [@rightAnimation]
        >
        <div class="toast__content">
          <div class="toast__icon">
            <i class="material-icons">{{ getIcon(toast.severity) }}</i>
          </div>
          <div class="toast__message">
            <div class="toast__summary">{{ toast.summary }}</div>
            @if (toast.detail) {
              <div class="toast__detail">{{ toast.detail }}</div>
            }
          </div>
          @if (toast.closable) {
            <button class="toast__close" (click)="removeToast(toast.id)">
              <i class="material-icons">close</i>
            </button>
          }
        </div>
      </div>
    }
  </div>
}

@if (bottomLeftToasts.length > 0) {
  <div class="toast__container toast__container--bottom-left">
    @for (toast of bottomLeftToasts; track toast) {
      <div
        class="toast__item"
        [ngClass]="'toast__item--' + toast.severity"
        [@leftAnimation]
        >
        <div class="toast__content">
          <div class="toast__icon">
            <i class="material-icons">{{ getIcon(toast.severity) }}</i>
          </div>
          <div class="toast__message">
            <div class="toast__summary">{{ toast.summary }}</div>
            @if (toast.detail) {
              <div class="toast__detail">{{ toast.detail }}</div>
            }
          </div>
          @if (toast.closable) {
            <button class="toast__close" (click)="removeToast(toast.id)">
              <i class="material-icons">close</i>
            </button>
          }
        </div>
      </div>
    }
  </div>
}